import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export function PortoBannerIllustration(props: SVGProps): JSX.Element {
  const { title = 'PersonIdentification', className, ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cn('fill-current', className)}
      viewBox="0 0 94 48"
      {...restProps}
    >
      <title>{title}</title>
      <g clipPath="url(#clip0_1539_7969)">
        <path
          d="M27.2833 21.9333V47.1014H1.61572L27.2833 21.9333Z"
          stroke="#AC96FF"
          fill="none"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
        <path
          d="M78.835 47.3932H71.9213L53.2002 11.6431H59.7785"
          fill="#AC96FF"
        />
        <path
          d="M64.1966 7.60266H27.5786V47.3931H64.1966V7.60266Z"
          fill="white"
        />
        <path
          d="M83.4655 47.2521C87.9082 47.2521 91.5097 43.6506 91.5097 39.2079C91.5097 34.7652 87.9082 31.1638 83.4655 31.1638C79.0229 31.1638 75.4214 34.7652 75.4214 39.2079C75.4214 43.6506 79.0229 47.2521 83.4655 47.2521Z"
          stroke="#AC96FF"
          fill="none"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
        <path
          d="M57.3056 20.7723C67.7053 20.7723 76.136 12.0608 76.136 1.3183H38.4751C38.4751 12.0645 46.9058 20.7723 57.3056 20.7723Z"
          stroke="white"
          fill="none"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
        <path
          d="M27.5788 15.6834L64.1968 15.6834V7.60644L27.5788 7.60644V15.6834Z"
          fill="#AC96FF"
        />
        <path
          d="M51.9413 11.6431H39.835"
          stroke="black"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
        <path
          d="M33.6685 41.4457H58.089"
          stroke="black"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
        <path
          d="M33.6685 44.4621H51.7878"
          stroke="black"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
        <path
          d="M45.895 30.1919C45.895 30.1919 45.6944 30.5237 45.1766 30.7388C44.863 30.8701 44.4364 30.9576 43.8676 30.9102C42.3506 30.7826 42.3944 28.5692 43.0507 26.7022C43.7108 24.8352 45.0198 24.2226 46.5587 25.0284C48.0975 25.8343 47.8969 27.1799 47.6526 27.6612C47.4047 28.1425 46.9744 28.6494 46.6863 29.5902C46.3982 30.5346 48.0318 31.5192 48.0318 31.5192L44.6917 32.6387L45.173 30.7388"
          stroke="black"
          strokeWidth="0.911622"
          strokeLinejoin="round"
        />
        <path
          d="M46.65 29.7984C46.65 29.7984 45.7238 28.7664 46.1176 28.183C46.5114 27.5996 46.2015 27.2094 46.0009 27.4318C45.8003 27.6543 45.4576 27.2604 45.4576 27.2604L45.1513 27.9715L42.792 27.5631C42.792 27.5631 43.1493 24.985 44.6481 24.7152C46.1468 24.4454 47.7476 24.8173 48.2836 26.1446C49.5343 29.2332 46.7338 30.2068 46.65 29.802V29.7984Z"
          fill="black"
          stroke="black"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
        <path
          d="M48.8592 26.3491C49.6103 26.3491 50.2193 25.7402 50.2193 24.989C50.2193 24.2378 49.6103 23.6288 48.8592 23.6288C48.108 23.6288 47.499 24.2378 47.499 24.989C47.499 25.7402 48.108 26.3491 48.8592 26.3491Z"
          fill="black"
          stroke="black"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
        <path
          d="M46.1064 35.1998C50.112 35.1998 53.3592 31.9525 53.3592 27.9469C53.3592 23.9412 50.112 20.694 46.1064 20.694C42.1007 20.694 38.8535 23.9412 38.8535 27.9469C38.8535 31.9525 42.1007 35.1998 46.1064 35.1998Z"
          stroke="black"
          strokeWidth="0.911622"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_1539_7969">
          <rect
            width="93"
            height="47.4153"
            fill="none"
            transform="translate(0.5 0.292358)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
